module.exports = __webpack_public_path__ + "img/rhombus-blue.6fcaae41.svg";